/**
 * Renders a JSON-LD structured data script tag. Data comes exclusively from
 * our own schema builders (schemas.ts) — never from user input — so the
 * innerHTML serialization is safe.
 */
export function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data, null, 0) }}
    />
  );
}

/** Creates an @id URL from a path relative to the site root. */
// eslint-disable-next-line react-refresh/only-export-components -- helper co-located with renderer for cohesion
export function orgId(path: string): string {
  return `https://forvisibility.com${path.startsWith('/') ? '' : '/'}${path}`;
}
